module.exports = __webpack_public_path__ + "img/disDelete.90adc103.svg";